import { Chip } from "@mui/material";
import clsx from "clsx";
import { FC, ReactNode } from "react";

import { MuiPaletteType } from "@ryde/shared";

import { PanelTopRightStatItemWrapper } from "./panel-top.elements.styled";

interface IPanelTopRightStatItemWrapper {
  selected?: string | number | ReactNode;
  total?: string | number | ReactNode;
  label: React.ReactNode;
  hideSelected?: boolean;
  hideTotal?: boolean;
  e2eId?: string;
  muiPalette?: MuiPaletteType;
}

export const PanelTopRightStatItem: FC<IPanelTopRightStatItemWrapper> = ({
  selected,
  label,
  total,
  hideSelected,
  hideTotal,
  muiPalette,
  e2eId = "panel-top-right-stat-item",
}) => {
  return (
    <PanelTopRightStatItemWrapper data-e2e={e2eId}>
      <div dir={"ltr"}>
        {!hideSelected && (
          <Chip
            size="small"
            sx={{ fontSize: "12px" }}
            color={muiPalette}
            label={selected}
          />
        )}
        {!hideTotal && !hideSelected && <span>/</span>}
        {!hideTotal && <Chip size="small" color={muiPalette} label={total} />}
      </div>

      <label
        className={clsx({
          error: muiPalette === "error",
        })}
      >
        {label}
      </label>
    </PanelTopRightStatItemWrapper>
  );
};
